import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import config from 'config/api';
import isArray from 'mout/lang/isArray';
import BlockRatio from 'components/BlockRatio';
import GetAppIcon from '@material-ui/icons/GetApp';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Paragrapher from 'components/UI/Paragrapher/Paragrapher';
import NPS from 'components/UI/NPS';
import Share from 'components/UI/Share';

const useStyles = makeStyles((theme) => ({
  root: {
    margin:8,
    paddingBottom:5,
    borderRadius:10,
    '& .MuiCardContent-root':{
      padding:0,
    }
  },
  title:{
    fontWeight:'bold',
    padding:'5px 15px',
  },
  imageWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  image: {
    position: 'relative',
    width: '100%',
    height: '100%',
    backgroundRepeat: "no-repeat",
    backgroundPosition: '50%',
    backgroundSize: 'cover',
  },
  button:{
    '& .MuiSvgIcon-root':{
      marginTop:0,
    }
  },
  dialog:{
    '& .MuiDialog-paper ':{
      minWidth:400,
      margin: 0,
      padding: theme.spacing(1),
      }
  },
  dialogContent:{
    padding: theme.spacing(2),
  },
  dialogActions:{
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  text: {
    whiteSpace: 'pre-wrap',
    padding: '.5em',
    lineHeight: '1.8',
  },
}));

function getFile (id, dbValue) {
  try {
    const values = JSON.parse(dbValue);
    if (values !== undefined && isArray(values) && values[0] && values[0].dest) {
      return config.documentationPath + '/' + id+'/'+ values[0].dest;
    }
  } catch (e) {
      console.log("getFile JSON.parse error", dbValue);
  }
  return '';
};


export default function DocumentationItem(props) {

  const { data } = props;
  const classes = useStyles();
  //console.log(data);

  const [open, setOpen] = React.useState(false);
  
  const image=getFile(data.id, data.documentationImage);
  const file=getFile(data.id, data.documentationFile);

  const handleClickOpen = (event) => {
    event.preventDefault();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog onClose={handleClose} className={classes.dialog} open={open}>
        <MuiDialogTitle disableTypography className={classes.dialogTitle}>
          <Typography variant="h6">{data.documentationTitle}</Typography>
            <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
              <CloseIcon />
            </IconButton>
        </MuiDialogTitle>
        <Box className={classes.dialogContent}>
        <Box className={classes.imageWrapper}>
          <BlockRatio ratio="16_9" style={{height: '100%'}}>
            <div className={classes.image} style={{backgroundImage: 'url('+image+'), linear-gradient(90deg, #2D5E77 0%, #4CA1A6 100%)'}}></div>
          </BlockRatio>
        </Box>
          <Typography gutterBottom className={classes.text}>
            <Paragrapher prettyfy={true} text={data.documentationContent}/>
          </Typography>
          <Box style={{textAlign:"left"}}>
          {config.NPS_documentation && 
          <Grid item xs={12} className={classes.shareWrapper}>
            <NPS module="documentation" id={data.id} data={data.nps} align="left"/>
          </Grid>
        }
        {config.Share_documentation && 
          <Grid item xs={12} className={classes.shareWrapper}>
            <Share module="documentation" id={data.id} title={data.documentationTitle} />
          </Grid>
        }
        </Box>
        </Box>

        <Box className={classes.dialogActions}>
          <a href={file}><Button onClick={handleClose} className={classes.button} size="medium" variant="contained" color="primary"><GetAppIcon/> Télécharger</Button></a>
        </Box>
      </Dialog>

      <Card className={classes.root}>
      <CardContent>
        <Box className={classes.imageWrapper}>
          <BlockRatio ratio="16_9" style={{height: '100%'}}>
            <div className={classes.image} style={{backgroundImage: 'url('+image+'), linear-gradient(90deg, #2D5E77 0%, #4CA1A6 100%)'}}></div>
          </BlockRatio>
        </Box>
        <Typography variant="h3" className={classes.title} color="primary" gutterBottom>
          {data.documentationTitle}
        </Typography>
      </CardContent>
      <CardActions>
        <Grid container align="center">
          <Grid xs={6} item>
            <a style={{verticalAlign:'middle'}} href="#" onClick={e=>{handleClickOpen(e)}}>Voir plus</a>
          </Grid>
          <Grid xs={6} item>
            <a href={file}><Button className={classes.button} size="medium" variant="contained" color="primary"><GetAppIcon/> Télécharger</Button></a>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/UI/Documentation/DocumentationItem.jsx